module.exports = __webpack_public_path__ + "static/media/tcfcolorlogo.86bd0a3a.svg";